<template>

  <!-- navigation -->
<header>
  <nav>
    <div class="branding">
      <router-link to="/">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="121"
              height="38"
              viewBox="0 0 121 38"
              fill="none"
            >
              <g clip-path="url(#clip0_646_5439)">
                <path
                  d="M22.4058 10.3083V27.6313C22.4058 29.5314 20.8699 31.0674 18.9697 31.0674V37.9396C24.6543 37.9396 29.278 33.3317 29.278 27.6313V10.3083C29.278 8.40814 30.814 6.87219 32.7141 6.87219V0C27.0137 0 22.4058 4.60785 22.4058 10.3083Z"
                  fill="url(#paint0_linear_646_5439)"
                />
                <path
                  d="M19.4606 9.56405L0 3.84778V11.8601L19.4606 17.5763V9.56405Z"
                  fill="url(#paint1_linear_646_5439)"
                />
                <path
                  d="M19.4607 19.619L5.71631 15.5812V23.5935L19.4607 27.6313V19.619Z"
                  fill="url(#paint2_linear_646_5439)"
                />
                <path
                  d="M48.3743 16.7371H45.1916V31.0515H41.5971V16.7371H39.5703V13.8394H41.5971V12.6201C41.5971 10.6408 42.1197 9.19989 43.1806 8.29732C44.2257 7.39475 45.8883 6.93555 48.1368 6.93555V9.89661C47.06 9.89661 46.3 10.1025 45.8566 10.4983C45.4133 10.91 45.2074 11.6067 45.2074 12.6043V13.8236H48.3901V16.7371H48.3743Z"
                  fill="white"
                />
                <path
                  d="M57.1625 14.2828C58.0334 13.792 59.0468 13.5544 60.2344 13.5544V17.2439H59.3318C57.9384 17.2439 56.8775 17.5923 56.1649 18.3048C55.4524 19.0174 55.0882 20.2366 55.0882 21.9943V31.0516H51.5254V13.8395H55.0882V16.3413C55.6107 15.4546 56.3074 14.7737 57.1625 14.2828Z"
                  fill="white"
                />
                <path
                  d="M79.1723 23.7676H66.0296C66.1404 25.1452 66.6471 26.2537 67.5655 27.0771C68.4839 27.9163 69.6082 28.328 70.9383 28.328C72.8543 28.328 74.216 27.5204 75.0078 25.9211H78.8556C78.333 27.5046 77.3988 28.803 76.0212 29.8164C74.6594 30.8298 72.9651 31.3365 70.9383 31.3365C69.2915 31.3365 67.8189 30.9723 66.5204 30.2281C65.222 29.4839 64.1928 28.4388 63.4644 27.1087C62.7202 25.7628 62.356 24.211 62.356 22.4375C62.356 20.6641 62.7202 19.1123 63.4327 17.7663C64.1453 16.4204 65.1587 15.3912 66.4571 14.6628C67.7555 13.9344 69.2598 13.5702 70.9383 13.5702C72.5693 13.5702 74.0102 13.9186 75.277 14.6311C76.5437 15.3437 77.5413 16.3412 78.238 17.608C78.9506 18.8906 79.2989 20.3632 79.2989 22.0258C79.2989 22.675 79.2673 23.2451 79.1723 23.7676ZM75.5778 20.9016C75.562 19.5873 75.0869 18.5422 74.1685 17.7505C73.2501 16.9588 72.11 16.5629 70.7641 16.5629C69.529 16.5629 68.4839 16.9588 67.613 17.7347C66.7421 18.5106 66.2196 19.5715 66.0454 20.9016H75.5778Z"
                  fill="white"
                />
                <path
                  d="M82.6878 17.7664C83.4004 16.4363 84.3821 15.3912 85.633 14.6628C86.8681 13.9186 88.2457 13.5544 89.7658 13.5544C90.8901 13.5544 91.9985 13.7919 93.0911 14.2828C94.1837 14.7736 95.0546 15.4228 95.7038 16.2304V7.93311H99.2982V31.0515H95.7038V28.4547C95.1179 29.2939 94.3104 29.9748 93.2811 30.5132C92.2519 31.0515 91.0643 31.3207 89.7342 31.3207C88.2299 31.3207 86.8681 30.9407 85.6172 30.1806C84.3821 29.4206 83.4004 28.3597 82.672 26.9979C81.9594 25.6361 81.5952 24.0843 81.5952 22.3584C81.611 20.6324 81.9752 19.1123 82.6878 17.7664ZM94.9754 19.334C94.4845 18.4631 93.8512 17.798 93.0594 17.3388C92.2677 16.8796 91.4126 16.6579 90.4942 16.6579C89.5758 16.6579 88.7208 16.8796 87.929 17.323C87.1373 17.7664 86.5039 18.4314 86.0131 19.2865C85.5222 20.1574 85.2847 21.1708 85.2847 22.3584C85.2847 23.546 85.5222 24.591 86.0131 25.4778C86.5039 26.3803 87.1531 27.0612 87.9449 27.5204C88.7524 27.9955 89.5917 28.2172 90.4942 28.2172C91.4126 28.2172 92.2677 27.9955 93.0594 27.5363C93.8512 27.0771 94.4845 26.412 94.9754 25.5253C95.4663 24.6385 95.7038 23.6093 95.7038 22.4217C95.7038 21.25 95.4663 20.2049 94.9754 19.334Z"
                  fill="white"
                />
                <path
                  d="M107.057 30.2281C105.743 29.4839 104.714 28.4388 103.969 27.1087C103.225 25.7628 102.845 24.211 102.845 22.4375C102.845 20.6799 103.225 19.1439 104.001 17.7822C104.777 16.4204 105.822 15.3912 107.152 14.6628C108.482 13.9344 109.971 13.5702 111.618 13.5702C113.264 13.5702 114.753 13.9344 116.083 14.6628C117.413 15.3912 118.474 16.4362 119.234 17.7822C120.01 19.1439 120.39 20.6957 120.39 22.4375C120.39 24.1793 119.994 25.747 119.202 27.0929C118.411 28.4547 117.334 29.4997 115.972 30.2281C114.61 30.9723 113.106 31.3365 111.459 31.3365C109.828 31.3365 108.356 30.9723 107.057 30.2281ZM114.04 27.5838C114.848 27.1404 115.497 26.4912 115.988 25.6203C116.495 24.7494 116.732 23.6885 116.732 22.4375C116.732 21.1866 116.495 20.1257 116.02 19.2706C115.545 18.3997 114.911 17.7505 114.119 17.323C113.328 16.8796 112.473 16.6738 111.554 16.6738C110.636 16.6738 109.797 16.8954 109.005 17.323C108.229 17.7663 107.611 18.4156 107.152 19.2706C106.693 20.1415 106.471 21.1866 106.471 22.4375C106.471 24.2902 106.946 25.7311 107.896 26.7287C108.847 27.7421 110.034 28.2488 111.475 28.2488C112.378 28.2488 113.233 28.0271 114.04 27.5838Z"
                  fill="white"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_646_5439"
                  x1="10.5787"
                  y1="3.71038"
                  x2="33.9134"
                  y2="27.0451"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#00FFFF" />
                  <stop offset="1" stop-color="#00C1BC" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_646_5439"
                  x1="6.65287"
                  y1="7.63627"
                  x2="29.9875"
                  y2="30.9709"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#00FFFF" />
                  <stop offset="1" stop-color="#00C1BC" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_646_5439"
                  x1="2.63806"
                  y1="11.6511"
                  x2="25.9727"
                  y2="34.9858"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#00FFFF" />
                  <stop offset="1" stop-color="#00C1BC" />
                </linearGradient>
                <clipPath id="clip0_646_5439">
                  <rect width="120.39" height="37.9396" fill="white" />
                </clipPath>
              </defs>
            </svg>
      </router-link>
    </div>
    <ul v-show="!moblie" class="naviagtion">
      <li><router-link active-class="active" to="/invest" class="link">Deals</router-link></li>
      <li><router-link active-class="active" to="/raise" class="link">Raise</router-link></li>
      <li class="relative dropdown">
        <a  href="https://linktr.ee/fredolearn" target="_blank" class="link">Learn</a>
          <!-- <ul class="submenu_main">
            <li><a href="https://fredolearn.substack.com/" class="link" target="_blank">Blog</a></li>
            <li><a href="https://readon.substack.com/" class="link" target="_blank">Blog</a></li>
          </ul>          -->
      </li>
      <li><router-link active-class="active" to="/howitworks" class="link">How it works</router-link></li>
    </ul>
    <div v-show="!moblie" v-if="!loggedIn" class="rightBx">
      <router-link to="/login" class="login_btn">Login</router-link>
    </div>
    <div class="login_img_div respo_hidden_login_icon" v-else>
      <router-link  to="/profile" class="beforlogin">
        <img src="../assets/image/login_img.png" alt="">
      </router-link>
    </div>

    <!-- mobile nav -->
    <div class="icon">
      <button @click="toggleMoblieNav" v-show="moblie" :class="{ 'icon-active': moblieNav}" v-if="!loggedIn">
        <svg class="hamburger-menu-cty" viewBox="0 0 100 100" id="hamburger" fill="currentcolor" >
            <path class="line top" d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20"></path>
            <path class="line middle" d="m 30,50 h 40"></path>
            <path class="line bottom" d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20"></path>
        </svg>
      </button>
       <div class="afterlogin"  @click="toggleMoblieNav" v-show="moblie" v-else>
        <img src="../assets/image/login_img.png" alt="">
      </div>
    </div>
    <transition name="mobile-nav" @click="closeModal">
    <ul class="dropdown-nav relative" v-show="moblieNav" v-bind="moblieNav">
      <li><router-link active-class="active" to="/invest" class="link">Invest</router-link></li>
      <li><router-link active-class="active" to="/raise" class="link">Raise</router-link></li>
      <li><a href="https://fredolearn.substack.com/" target="_blank" class="link">Blog</a></li>
      <!-- <li><router-link to="/events" class="link">Community</router-link></li> -->
      <li><router-link active-class="active" to="/howitworks" class="link">How it works</router-link></li>
      <li><router-link active-class="active" to="/profile" class="link" v-if="loggedIn">Dashboard</router-link></li>
      <div v-if="!loggedIn" class="resp_rightBx">
        <router-link to="/login" class="resp_login_btn">Login</router-link>
      </div>
      <div class="togl_scnd_div" v-if="loggedIn">
        <router-link active-class="active" to="/profile/setting"   exact class="togl_btn">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14Z" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M18 14C17.879 14.2742 17.9465 14.7051 18 15C18.0535 15.2949 17.7904 14.7857 18 15V15C18.169 15.1689 17.9085 15.7793 18 16C18.0915 16.2207 19 16.7611 19 17C19 17.2389 18.0915 16.7793 18 17C17.9085 17.2207 18.169 17.8311 18 18C17.8311 18.169 17.2207 17.9085 17 18C16.7793 18.0915 17.2389 19 17 19C16.7611 19 16.2207 18.0915 16 18C15.7793 17.9085 16.1689 18.169 16 18H15C14.7857 17.7904 15.2949 18.0535 15 18C14.7051 17.9465 14.2742 17.879 14 18C13.7311 18.1152 13.1615 17.7561 13 18C12.8385 18.2439 13.0012 18.7075 13 19V19C13 19.4822 12.341 19.659 12 20C11.659 20.341 11.4822 21 11 21C10.5178 21 10.341 20.341 10 20C9.65902 19.659 9 19.4822 9 19V19C8.99296 18.6991 9.1751 18.2448 9 18C8.8249 17.7552 8.28249 18.1039 8 18C7.7258 17.879 7.2949 17.9465 7 18C6.7051 18.0535 7.21425 17.7904 7 18V18C6.83114 18.169 6.22072 17.9085 6 18C5.77928 18.0915 5.23894 19 5 19C4.76106 19 5.22072 18.0915 5 18C4.77928 17.9085 4.16886 18.169 4 18C3.83095 17.8311 4.0915 17.2207 4 17C3.9085 16.7793 3 17.2389 3 17C3 16.7611 3.9085 16.2207 4 16C4.0915 15.7793 3.83095 16.1689 4 16V15C4.20958 14.7857 3.94653 15.2949 4 15C4.05347 14.7051 4.12101 14.2742 4 14C3.88476 13.7311 4.2439 13.1615 4 13C3.7561 12.8385 3.29253 13.0012 3 13V13C2.51779 13 2.34098 12.341 2 12C1.65902 11.659 1 11.4822 1 11C1 10.5178 1.65902 10.341 2 10C2.34098 9.65902 2.51779 9 3 9V9C3.3009 8.99296 3.75519 9.1751 4 9C4.24481 8.8249 3.89611 8.28249 4 8C4.12101 7.7258 4.05347 7.2949 4 7C3.94653 6.7051 4.20958 7.21425 4 7V7C3.83095 6.83114 4.0915 6.22072 4 6C3.9085 5.77928 3 5.23894 3 5C3 4.76106 3.9085 5.22072 4 5C4.0915 4.77928 3.83095 4.16886 4 4C4.16886 3.83095 4.77928 4.0915 5 4C5.22072 3.9085 4.76106 3 5 3C5.23894 3 5.77928 3.9085 6 4C6.22072 4.0915 5.83114 3.83095 6 4H7C7.21425 4.20958 6.7051 3.94653 7 4C7.2949 4.05347 7.7258 4.12101 8 4V4C8.26888 3.88476 8.83848 4.2439 9 4C9.16152 3.7561 8.99883 3.29253 9 3V3C9 2.51779 9.65902 2.34098 10 2C10.341 1.65902 10.5178 1 11 1C11.4822 1 11.659 1.65902 12 2C12.341 2.34098 13 2.51779 13 3V3C13.0012 3.29253 12.8385 3.7561 13 4C13.1615 4.2439 13.7311 3.88476 14 4C14.2742 4.12101 14.7051 4.05347 15 4C15.2949 3.94653 14.7857 4.20958 15 4V4C15.1689 3.83095 15.7793 4.0915 16 4C16.2207 3.9085 16.7611 3 17 3C17.2389 3 16.7793 3.9085 17 4C17.2207 4.0915 17.8311 3.83095 18 4C18.169 4.16886 17.9085 4.77928 18 5C18.0915 5.22072 19 4.76106 19 5C19 5.23894 18.0915 5.77928 18 6C17.9085 6.22072 18.169 5.83114 18 6V7C17.7904 7.21425 18.0535 6.7051 18 7C17.9465 7.2949 17.879 7.7258 18 8V8C18.1152 8.26888 17.7561 8.83848 18 9C18.2439 9.16152 18.7075 8.99883 19 9V9C19.4822 9 19.659 9.65902 20 10C20.341 10.341 21 10.5178 21 11C21 11.4822 20.341 11.659 20 12C19.659 12.341 19.4822 13 19 13V13C18.7075 13.0012 18.2439 12.8385 18 13C17.7561 13.1615 18.1152 13.7311 18 14V14Z" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <h2> Settings</h2>
        </router-link>
        <button @click.prevent="handleLogout" class="togl_btn">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2H17C17.4301 2 18.6959 2.64576 19 3C19.3041 3.35424 19 3.49904 19 4V17C19 17.501 19.3041 17.6458 19 18C18.6959 18.3542 17.4301 19 17 19H14" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8 7L3 11L8 16" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M3 11H14" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                <h2>Logout</h2>
        </button>
      </div>
    </ul>

    </transition>
  </nav>
</header>
  <!-- End navigation -->
</template>

<script>
export default {
  // -next-line vue/multi-word-component-names
  name: "Header",
  props: ["loggedIn"],
  data() {
    return {
     islogin:false,
     moblie:null,
     moblieNav:null,
     windowWidth:null,
     isOpen: false,
    }
  },
  created(){
    window.addEventListener("resize", this.checkScreen);
    this.checkScreen();
  },
  methods: {
    handleLogout(){
        this.$store.dispatch("logout");
    },
    toggleMoblieNav(){
      this.moblieNav = !this.moblieNav;
    },
    checkScreen(){
      this.windowWidth = window.innerWidth;
      if(this.windowWidth <= 880){
        this.moblie = true;
        return;
      }
      this.moblie = false;
      this.moblieNav = false;
      return;
    },
    closeModal () {
      this.moblieNav = false;
    },

  },
};
</script>
<style lang="postcss" scoped>
header{ @apply flex flex-row justify-center items-center  z-20 w-full transition-all;
  nav{ @apply container z-10 flex flex-row justify-between items-center py-4 transition-all m-0;
    @media (min-width: 1140px) {
      nav{
        @apply max-w-[1140px];
      }
    }
    ul{
      li{
        a{ @apply text-whitergb text-[1.25rem] hover:text-borderclr hover:opacity-100 !important;
            &.active {
              @apply text-borderclr border-b-2 border-borderclr;
            }
         }
           ul.submenu_main{
           @apply z-[11] p-5 pt-2 bg-gradient-to-br from-clr6 to-clr7 rounded-b-[1rem] before:absolute before:-top-[1.5rem] before:left-0 before:h-11 before:w-[51%] before:bg-clr6 before:transform before:-skew-y-12 before:rounded-tl-lg after:absolute after:-top-[1.5rem] after:right-0 after:h-11 after:w-[50%] after:bg-gradient-to-br from-clr6 to-clr7 after:transform after:skew-y-12 after:rounded-tr-lg;
             li{
               @apply py-1 text-center;
               a{
                 @apply text-[1rem] text-drpdwntxt font-medium hover:text-whitergb !important;
               }
              }
         }
      }
    }
    .branding{ @apply flex items-center justify-between;
      svg{
        transition: .5s ease all;
      }
    }
    .naviagtion{
      @apply flex items-center justify-center gap-14 flex-1;
    }
    .icon{ @apply z-20 sticky top-0;
      .icon-active{
        transform: rotate(180deg);
      }
    }
    .dropdown-nav{ @apply flex flex-col fixed w-full h-full  bg-black top-0 left-0 z-10 pt-20 pl-10;
      li{ @apply  my-4;
      }
      .rightBx{
        @apply mt-4;
      }
      .togl_scnd_div{ @apply absolute bottom-4 w-full;
        .togl_btn{
          @apply text-whitergb flex items-center my-4 mx-0;
          h2{
            @apply text-xl;
          }
          svg{
            @apply mr-4;
          }
        }
      }
    }
  }
}
@media (min-width: 300px) and (max-width: 552px) {
  header {
    @apply container sticky bg-navbg top-0 !important;
  }
}
.rightBx{
  .login_btn{ @apply  lg:inline-block  text-xs px-9 py-2  border-2 rounded-[1.25rem] text-menutext border-borderclr lg:mt-0 hover:text-white;
  }
}
.resp_rightBx{
  .resp_login_btn{ @apply  lg:inline-block text-xs px-9 py-2  border-2 rounded-[0.9rem] text-menutext border-borderclr lg:mt-0 hover:text-white;
  }
}
.login_img_div{
  @apply ml-14 z-20;
  .beforlogin{
    @apply max-w-[54px];
  }
}
.afterlogin{
  img{
    @apply max-w-[50px];
    }
  }

.submenu_main{
   position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 65px;
    width: 200px;
    display: none;
}
.dropdown:hover .submenu_main{
 display: block;
}
li.relative.dropdown::before {
    content: '';
    height: 14px;
    position: absolute;
    bottom: -7px;
    width: 100%;
}
/* new svg */
.hamburger-menu-cty{
  transition: all .5s ease;
  user-select: none;
  -webkit-user-select: none;
  width: 50px;
  height: 50px;
  z-index: 99 ;
}
.hamburger-menu-cty .line{
  fill: none;
    stroke: #32CDC9;
    stroke-width: 5.5;
    stroke-linecap: round;
    transition: all .5s ease;
}
.hamburger-menu-cty .top{
      stroke-dasharray: 40 160;
}
.hamburger-menu-cty .middle{
  stroke-dasharray: 40 142;
    transform-origin: 50%;
}
.hamburger-menu-cty .bottom{
  stroke-dasharray: 40 85;
    transform-origin: 50%;
}
.icon-active .hamburger-menu-cty .top{
    stroke-dashoffset: -64px;
}
.icon-active .hamburger-menu-cty .middle{
   transform: rotate(90deg);
}
.icon-active .hamburger-menu-cty .bottom{
   stroke-dashoffset: -64px;
}
.icon-active .hamburger-menu-cty{
   transform: rotate(45deg);
}

</style>
